export default __webpack_public_path__ + "static/media/calendar.86bf4084.svg";